import React, {useCallback} from 'react';
import form_styles from "../Form/Form.module.css";
import { ReactComponent as EnregistrerIcon } from '../../icons/enregistrer.svg';
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {copyToClipboard} from "../../services/UtilsService";
import {useModal} from "../../contexts/ModalContext";

const BtnCopy = ({ copy = "", title = "Copier" }) => {
    const { showModal } = useModal();

    const handleSuccess = useCallback((message = "Statistiques récupérées") => {
        showModal('success', { children: message, timeout: 1500 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 1500 });
    }, [showModal]);

    return (
        <button className={`btn_pastille`} title={title} onClick={ () => copyToClipboard(copy, handleSuccess) }>
            <FontAwesomeIcon icon={faCopy} style={{cursor: "pointer"}}/>
        </button>
    );
};

export default BtnCopy;
